
import { Button } from "@/components/ui/button";
import { GlowButton } from "@/components/ui/glow-button";
import { primeEffects, playButtonSound } from "@/utils/effects";

interface DemoSubmitButtonProps {
  selectedPlayers: string[];
  submitting: boolean;
  onSubmit: () => void;
}

export const DemoSubmitButton = ({
  selectedPlayers,
  submitting,
  onSubmit
}: DemoSubmitButtonProps) => {
  // Prime effects when component mounts or when selected players changes
  const readyToSubmit = selectedPlayers.length === 3;
  
  // When we have 3 players selected, prime effects to ensure they are ready
  if (readyToSubmit) {
    primeEffects();
  }
  
  const handleSubmit = () => {
    if (!readyToSubmit || submitting) return;
    
    // Use special voting button sound effect
    playButtonSound();
    onSubmit();
  };

  return (
    <div className="flex justify-center mt-4 mb-6">
      {readyToSubmit ? (
        <GlowButton 
          onClick={handleSubmit}
          disabled={submitting}
          size="sm"
          glowColors={['#33C3F0', '#0EA5E9', '#8B5CF6', '#D946EF']}
          glowMode="colorShift"
          glowBlur="strong"
          glowScale={1.5}
          glowDuration={4}
          className="transition-all duration-300 select-none px-10 py-2"
        >
          {submitting ? "Submitting..." : "Submit Vote"}
        </GlowButton>
      ) : (
        <Button 
          disabled={true}
          size="sm"
          className="transition-all duration-300 select-none px-10 py-2"
        >
          {submitting ? "Submitting..." : "Submit Vote"}
        </Button>
      )}
    </div>
  );
}
